import axios from 'axios'
import router from '../router';
import { Message } from 'element-ui'
import i18n from '../i18n'
import { getRefreshToken, saveTokens } from './auth.js'
import domainManager from './domainManager'

const getBaseUrl = () => {
	// 纯远程域名：仅返回域名管理器从远程拉取的结果（无本地兜底）
	return domainManager.getBaseUrl()
}

// 创建 axios 实例时不固定 baseURL，由请求拦截器动态设置
const http = axios.create({
	timeout: 1000 * 30
})

/**
 * 请求拦截 — 动态设置 baseURL
 */
http.interceptors.request.use(async config => {
	// 确保远程域名已加载完成再设置 baseURL
	await domainManager.ready()
	config.baseURL = getBaseUrl()
	const accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	// 国际化：后端根据此 header 返回对应语言的消息
	const locale = i18n.locale;
	config.headers['Accept-Language'] = locale;
	config.headers['X-Locale'] = locale;
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	// 收到响应即说明当前域名可达，重置连续失败计数，避免短暂恢复后被旧计数误判
	domainManager.reportSuccess()
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		const refreshToken = getRefreshToken();
		if (!refreshToken) {
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			exit();
			return Promise.reject(response.data);
		})
		saveTokens(data);
		response.config.headers.accessToken = encodeURIComponent(data.accessToken);
		// 重新发送刚才的请求
		return http(response.config)
	} else {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	// 仅对「域名失效/服务不可达」类错误切换域名：网络无响应 或 命中可切换状态码（404/5xx/408）；401 认证错误不切换
	const status = error.response ? error.response.status : 0
	const switchable = !error.response || domainManager.isSwitchableStatus(status)
	if (switchable && domainManager.reportFailure()) {
		console.log('[DomainManager] 请求失败(' + (error.response?.status || '无响应') + ')，重试域名:', error.config.url)
		return http(error.config)
	}
	if (error.response) {
		switch (error.response.status) {
			case 400:
				Message({
					message: error.response.data,
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 401:
				exit();
				break
			case 405:
				Message({
					message: i18n.t('http.methodError'),
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 502:
				console.log('[DomainManager] 502 网关错误，已重试所有域名')
				Message({
					message: i18n.t('http.serverError'),
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 404:
			case 500:
				Message({
					message: i18n.t('http.serverError'),
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 501:
				Message({
					message: i18n.t('http.notSupport'),
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
		}
	}
	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
